import AuthService from './auth.service'
import GigaofficeService from './gigaoffice.service'

export const authService = new AuthService('auth')
export const gigaofficeService = new GigaofficeService('gigaoffice')